import { gql } from '@apollo/client';

export const GET_APP_CONFIG_QUERY = gql`
  query GetAppConfig {
    getAppConfig {
      user {
        email
      }
      organization {
        id
        name
        theme
      }
      userDataSources {
        dataSource
        namespace
        isInsurer
      }
    }
  }
`;
